import * as PropTypes from 'prop-types'
import Alert from 'react-bootstrap/Alert'
import Alerts from 'utils/Alerts'
import { useAlertActions } from './actions'

/**
 * @param link {string} Alerts with actual links should have some call to action. If you need a link in a specific part, pass a formatted React component instead
 * @param id Only needed if you're not supplying your own close function
 * @param superClose A custom closer function - that should define which list to close with {@link closeAlert}
 * @param alert {{ content: string, link: string, progress: number, maxProgress: number, type: string }}
 * @todo split this element into singleAlert (that removes its own ID) and multipleAlert (custom msg and closes a whole list at once)
 */
export default function ClickableAlert({ link, id = null, onClose: superClose = null, ...alert }) {
	const [onClick, onClose] = useAlertActions(id, link, superClose)
	return <Alert dismissible variant={alert.type || Alerts.TYPES.INFO} {...{ onClose, onClick }}>
		{alert.maxProgress? <progress value={alert.progress} max={alert.maxProgress}/> : null}
		{alert.content}
	</Alert>
}

ClickableAlert.propTypes = {
	type       : PropTypes.oneOf(Object.values(Alerts.TYPES)).isRequired,
	link       : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	id         : PropTypes.number,
	onClose    : PropTypes.func,
	content    : PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	progress   : PropTypes.number,
	maxProgress: PropTypes.number,
}

/** One-third of the screen occupied by roughly 50px alerts */
ClickableAlert.MAX_ALERTS = Math.floor(window.innerHeight / 3 / 50)
ClickableAlert.MAX_ORDERS = 4
